import type { ErrorInfo } from 'react';

export interface ClientErrorPayload {
  message: string;
  stack?: string;
  componentStack?: string;
  url: string;
  userAgent?: string;
}

const CLIENT_ERROR_ENDPOINT = '/api/logs/client-error';

export const logClientError = async (error: Error, info?: ErrorInfo) => {
  if (typeof window === 'undefined') return;

  const payload: ClientErrorPayload = {
    message: error.message,
    stack: error.stack,
    componentStack: info?.componentStack ?? undefined,
    url: window.location.href,
    userAgent: window.navigator.userAgent,
  };

  const isDev = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);

  if (isDev) {
    // eslint-disable-next-line no-console
    console.error('Captured client error (dev):', payload);
    return;
  }

  try {
    await fetch(CLIENT_ERROR_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (loggingError) {
    // eslint-disable-next-line no-console
    console.error('Failed to log client error', loggingError);
  }
};
